export default {
  computed: {
    combineStyles () {
      if (!this.$props.styles) {
        return false;
      }
      let styles = [this.$props.styles];
      if (this.$props.styles.width) {
        styles.push({ flexBasis: 'auto' });
        styles.push({ flexGrow: '0' });
      }
      return styles;
    }
  }
}
